export const productsIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX || '';
export const productsQuerySuggestionsIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_QUERY_SUGGESTIONS_INDEX || '';
